import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getAgreements } from "@/Services/TherapyApi/LegalAgreements";

import useLegalAgreementStore from "@/Modules/LegalAgreement/Store";
import useAppStore from "@/Modules/App/Store";

async function getUserLegalAgreementsAH(customerId: string, userId: string | undefined) {
  const legalAgreementStore = useLegalAgreementStore();
  const appStore = useAppStore();

  legalAgreementStore.isLoading = true;

  try {
    legalAgreementStore.legalAgreements = await getAgreements(customerId, userId);
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    legalAgreementStore.isLoading = false;
  }
}

export default getUserLegalAgreementsAH;
